<template>
    <div id="forecast-topbar">
        <div v-if="isLoading || (sales !== null && sales !== undefined)" class="info">
            <div class="item date">{{ date }}</div>
            <div class="item row">
                <span class="label">{{ $t('production.select.sale') }}</span
                ><span class="value" v-if="!isLoading">{{ formatCurrency(sales) }}</span>
                <span class="value" v-else>...</span>
            </div>
        </div>
    </div>
</template>

<script>

import { formatCurrency } from "@/utils/formatters";

export default {
    name: 'ForecastTopbar',
    props: { date: { type: String }, sales: { type: Number }, isLoading: { type: Boolean } },
    data() {
        return {
        }
    },
    methods: {
        formatCurrency(amount) {
            return formatCurrency(amount)
        }
    }
}
</script>
<style lang="scss" scoped>
#forecast-topbar {
    .info {
        display: flex;
        padding: 8px;
        border-radius: 4px;
        background-color: #fff;
        justify-content: space-between;
        width: fit-content;
        margin: 0 auto;
        column-gap: 50px;
        .item {
            padding: 8px;
            padding-left: 30px;
            height: 32.5px;

            &.date {
                @include background($image: img('input_date_cccccc.svg'), $size: 20px, $position: left center);
            }
            &.row {
                @include background($image: img('menu_sales_grey.svg'), $size: 20px, $position: left center);
                .value {
                    font-family: $text-bold;
                    margin-left: 8px;
                }
            }
        } 
    }
}
</style>
